import { useFeatureFlags } from '@funtech-int/yango-shared';

import { AppErrors } from '../../error-boundary-context/error-map/map';
import { useHandleError } from '../../error-boundary-context/context';

export const useDefaultOnError = () => {
    const { flags } = useFeatureFlags();
    const handleError = useHandleError();

    const defaultPlayerError = flags.get('defaultPlayerError', 'string', '');
    const onError = () => handleError(defaultPlayerError as AppErrors);
    return onError;
};
